import { render, staticRenderFns } from "./modalMsg.vue?vue&type=template&id=022c5914&scoped=true"
import script from "./modalMsg.vue?vue&type=script&lang=js"
export * from "./modalMsg.vue?vue&type=script&lang=js"
import style0 from "./modalMsg.vue?vue&type=style&index=0&id=022c5914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022c5914",
  null
  
)

export default component.exports